"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconFavoritesActive = void 0;
var React = __importStar(require("react"));
var styled_components_1 = require("styled-components");
var IconFavoritesActive = function (props) {
    var theme = styled_components_1.useTheme();
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
        React.createElement("g", { stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            React.createElement("rect", { id: "Padding", x: 0, y: 0, width: 24, height: 24 }),
            React.createElement("path", { d: "M21.9476,9.5109 C21.8276,9.1519 21.5236,8.8959 21.1526,8.8379 L15.4406,7.9619 L12.9026,2.5329 C12.5706,1.8219 11.4296,1.8219 11.0976,2.5329 L8.5586,7.9619 L2.8476,8.8379 C2.4766,8.8959 2.1716,9.1519 2.0526,9.5109 C1.9326,9.8689 2.0216,10.2589 2.2846,10.5289 L6.4476,14.8129 L5.4756,20.7959 C5.4106,21.1959 5.5716,21.5879 5.8966,21.8179 C6.2066,22.0369 6.6056,22.0599 6.9386,21.8759 L11.9996,19.0659 L17.0616,21.8759 C17.2116,21.9589 17.3746,21.9999 17.5366,21.9999 C17.7356,21.9999 17.9326,21.9389 18.1036,21.8179 C18.4286,21.5879 18.5896,21.1959 18.5246,20.7969 L17.5526,14.8129 L21.7156,10.5289 C21.9776,10.2589 22.0676,9.8689 21.9476,9.5109 L21.9476,9.5109 Z", id: "Path", fill: !!theme ? (theme.name !== 'privalia' ? theme.colors.main.base : theme.colors.gold.s50) : '#EC008C' }))));
};
exports.IconFavoritesActive = IconFavoritesActive;
exports.IconFavoritesActive.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconFavoritesActive;
